import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { CarouselMainState } from './CarouselMainState.state';
import { PromoCarouselNav } from './CarouselPromoNav';
import { PromoCarouselContent } from './CarouselPromoContent';
import { MainContent } from 'src/domains/layouts/shared/layout/Layout.style';
import { useCommon } from 'src/AppState/Common';

export const CarouselPromoComponent = observer(() => {
    const { websocketV2, appCasinoState, sdkStaff, cmsState, trpcClient } = useAppStateContext();
    const common = useCommon();
    const [carouselMainState] = useState(
        () =>
            new CarouselMainState(
                appCasinoState.gameStore,
                websocketV2,
                sdkStaff,
                cmsState.cmsTranslations,
                cmsState.languagesState,
                cmsState.cmsDisplayOrderState,
                trpcClient,
                common
            )
    );

    const key = `${carouselMainState.cmsTranslationsPromoCarouselList.length}-${carouselMainState.carouselMode}-${carouselMainState.carouselStateItem.isEditMode ? 'editMode' : 'newMode'}`;

    return (
        <MainContent data-test='promo-carousel'>
            <PromoCarouselNav carouselMainState={carouselMainState} />
            <PromoCarouselContent
                key={key}
                promoCarouselState={carouselMainState.carouselStateItem}
            />
        </MainContent>
    );
});
